
<template>
  <div v-if="data && team" v-wechat-title="title">
    <div class="topHead">
      <img :src="data.team.teamTitleUrl">
    </div>
    <div class="groupRectBase">
      <div class="topIcon">
        <van-row>
          <van-col span="12"><span @click="onBack"><i class="iconfont iconback" /> 返回</span></van-col>
          <van-col span="12" class="rigth"><span @click="onHome"><i class="iconfont iconshouye" /> 首页</span></van-col>
        </van-row>
      </div>
      <div class="commodityRect">
        <img :src="commodityIcon">
      </div>
      <div class="usersRect">
        <div v-for="(item,index) in team.member" :key="index" class="userRect">
          <van-image
            round
            width="100%"
            :src="item.icon?item.icon:'/img/defaultIcon.jpg'"
            :style="item.isMy?'border: 2px solid '+data.team.baseColor:'border: 2px solid #fff;'"
          />
        </div>
        <template v-if="data.team.groupNum>team.member.length">
          <div v-for="index in (data.team.groupNum-team.member.length)" :key="index" class="userRect">
            <van-image
              round
              width="100%"
              src="/img/GroupEmpty.png"
            />
          </div>
        </template>
      </div>
    </div>

    <div class="downButtonRect">
      <div v-if="team.isInTeam && !team.isFinish" class="downButton">
        <van-button type="default" size="large" :color="data.team.baseColor" @click="onShare">分享给朋友</van-button>
      </div>
      <div v-if="team.isInTeam && team.isFinish" class="downButton">
        <van-row>
          <van-col span="11"><van-button type="default" size="large" :color="data.team.baseColor" @click="onShare">分享给朋友</van-button></van-col>
          <van-col span="11" offset="2"><van-button type="default" size="large" :color="data.team.baseColor" @click="onGetGift">领取奖励</van-button></van-col>
        </van-row>
      </div>
      <div v-if="!team.isInTeam && !team.isFinish" class="downButton">
        <van-button type="default" size="large" :color="data.team.baseColor" @click="OnEnterTeam">加入队伍</van-button>
      </div>
      <div v-if="!team.isInTeam && team.isFinish" class="downButton">
        <van-button type="default" size="large" :color="data.team.baseColor" @click="onMyNewTeam">组建自己的队伍</van-button>
      </div>
    </div>
    <wxShare v-model="showShare" :title="shareTitle" :desc="shareAbout" :timeline="shareTimeline" :url="shareUrl" :img="shareIcon" @onFinish="onShareFinish" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Image, Dialog, Toast } from 'vant'
import wxShare from '@/components/wxShare'
import Cookies from 'js-cookie'
import commondata from '@/commondata.js'
import { GetSelfUrl } from '@/utils/request'
export default {
  components: {
    [Button.name]: Button,
    [Image.name]: Image,
    [Dialog.name]: Dialog,
    [Toast.name]: Toast,
    wxShare
  },
  data() {
    return {
      title: '拼团购',
      backurl: '/store/index',
      id: undefined,
      data: undefined,
      team: undefined,
      key: undefined,
      commodityIcon: undefined,
      showShare: false,
      shareTitle: '',
      shareAbout: '',
      shareTimeline: '',
      shareUrl: '',
      shareIcon: ''
    }
  },
  created() {
    this.id = this.$route.params.id
    if (this.id) {
      Cookies.set('groupKey_', this.id)
    } else {
      Cookies.remove('groupKey_')
      this.$router.push('/group/group')
      return
    }
    this.init()
  },
  beforeRouteLeave(to, from, next) {
    Toast.clear()
    next()
  },
  methods: {
    onShareFinish() {
      this.shareUrl = undefined
    },
    init() {
      request({
        url: '/StoreHelper/getGroupBuyTeam',
        method: 'get',
        params: { id: this.id }
      }).then(response => {
        console.log('response')
        if (!response.success) {
          return
        }
        this.team = response.data
        this.key = this.team.teamKey
        this.initGroup()
        this.updateDiyUrl()
        // this.title = this.data.team.shortName
      })
    },
    initGroup() {
      request({
        url: '/StoreHelper/getGroupBuy',
        method: 'get',
        params: { key: this.key }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
        this.shareTitle = this.data.team.shareTitle
        this.shareAbout = this.data.team.shareAbout
        this.shareTimeline = this.data.team.shareTimeline
        this.shareIcon = this.data.team.shareIcon
        this.shareUrl = GetSelfUrl() + 'group/team/' + this.id + '?system=' + commondata.systemBase
        this.title = this.data.team.shortName
        this.data.team.teamTitleUrl = '/grouptest/hbtitle.jpg'
      })
    },
    updateDiyUrl() {
      if (this.team.commodity.diyType === 'NONE') {
        return
      }
      if (!this.team.commodity.diyIcon) {
        return
      }
      const url = this.team.commodity.diyIcon +
        '?key=' + this.key +
        '&specificationId=' + this.team.commodity.specificationId +
        '&nickName=' + encodeURIComponent(this.team.nickName) +
        '&certificateTeam=' + encodeURIComponent(this.team.certificateTeam) +
        '&certificateId=' + encodeURIComponent(this.team.certificateId)
      if (url !== this.commodityIcon) {
        this.commodityIcon = url
      }
    },
    onBack() {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/group/groupCommodity/' + this.key)
    },
    onHome() {
      this.$router.push('/store/index')
    },
    onShare() {
      this.showShare = true
    },
    OnEnterTeam() {
      const idStr = this.id ? '?id=' + this.id : ''
      this.$router.push('/group/group/' + this.key + idStr)
    },
    onMyNewTeam() {
      Cookies.remove('groupKey_')
      this.$router.push('/group/group/' + this.key)
    },
    onGetGift() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '正在创建订单中......'
      })
      request({
        url: '/StoreHelper/groupBuyCreateOrder',
        method: 'get',
        params: { id: this.id }
      }).then(response => {
        Toast.clear()
        if (!response.success) {
          return
        }
        if (response.data.isNewOrder) {
          this.$router.push('/store/order/' + response.data.orderId)
          return
        }
        Dialog.alert({
          title: '检查到相关订单',
          message: '检查到您有相关订单，是否前往查看？如需重新下单，请取消相关订单即可！'
        }).then(() => {
          this.$router.push('/store/order/' + response.data.orderId)
        })
      })
    }
  }
}
</script>
<style scoped>
.topIcon{
  padding:0.5em 1em 0 1em;
  color: #999;
  font-size: 0.8em;
}
.topHead img{
  width: 100%;
}
.usersRect{
  display:flex;
  margin: 1em 2em;
  /* flex-flow: wrap; */
}
.usersRect .userRect{
  padding: 0.2em;
  width: 20%;
  flex: 1;
}

.usersRect .empty i{
  color: #fff;
  top: 50%;
  position: absolute;
  transform: translate(-50%,-50%);
}
.commodityRect{
  padding: 0 4em 1em 4em;
  border-bottom: 2px solid #f1f1f1;
}
.commodityRect img{
  width: 100%;
}
.downButtonRect{
  margin:1em;
}
.downButton{
  border-radius: 0.4em;
  overflow: hidden;
}
</style>
